import { Routes, Route } from "react-router-dom";
import News from "./Pages/News";
import NewsDetail from "./Pages/News/NewsFeed/NewsDetail";
function AppRoutes({ navigateTo }) {
  return (
    <Routes>
      <Route exact path="/" element={<News navigateTo={navigateTo} />} />
      <Route
        exact
        path="/news/:id"
        element={<NewsDetail navigateTo={navigateTo} />}
      />
    </Routes>
  );
}

export default AppRoutes;
